import { FC } from 'react';
import request from 'images/request.svg';

interface RequestIconProps {
  width: string;
  height: string;
}

const RequestIcon: FC<RequestIconProps> = (props): JSX.Element => {
  const { width, height } = props;
  return <img width={width} height={height} src={request} alt="request-icon" />;
};
export default RequestIcon;
